import React, { Fragment, Component, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LanguageProvider } from '../../i18n';
import WhatsAppButton from '../../components/WhatsAppButton';
import SiteSchema from '../../components/Seo/SiteSchema';
import Analytics from '../../components/Analytics';
import HomePageOne from '../Pages/HomePageOne'
import AboutPage from '../Pages/AboutPage'
import PracticePage from '../Pages/PracticePage'
import PracticeArea from '../Pages/PracticeArea'
import PracticeSinglePage from '../Pages/PracticeSinglePage'
import TeamPage from '../Pages/TeamPage'
import ContactPage from '../Pages/ContactPage'
import BlogFullWidth from '../Pages/BlogFullWidth'
import BlogTag from '../Pages/BlogTag'
import './App.css';
import BlogPage from '../../components/Blog';
import NotFound from '../Pages/NotFound';

// The admin (MUI editor, Quill, GitHub client) loads only when visited, so it
// adds nothing to the public site's bundle.
const Admin = lazy(() => import('../Pages/Admin'));
const AdminPanel = lazy(() => import('../Pages/AdminPanel'));
const adminFallback = <div style={{ minHeight: '100vh', background: '#1a2a4a' }} />;

class App extends Component {
    render() {
        return (
            <Fragment>
                <LanguageProvider>
                    <SiteSchema />
                    <Analytics />
                    <BrowserRouter>
                        <ToastContainer autoClose={2500} position="top-center" />
                        <Routes>
                            <Route exact path="admin" element={<Suspense fallback={adminFallback}><Admin /></Suspense>} />
                            <Route exact path="adminPanel" element={<Suspense fallback={adminFallback}><AdminPanel /></Suspense>} />
                            <Route exact path="/" element={<HomePageOne />} />
                            <Route exact path="about" element={<AboutPage />} />
                            <Route exact path="practice" element={<PracticePage />} />
                            <Route exact path="practice/:slug" element={<PracticeArea />} />
                            <Route exact path="practice-details" element={<PracticeSinglePage />} />
                            <Route exact path="blogs" element={<BlogFullWidth />} />
                            <Route exact path="contact" element={<ContactPage />} />
                            <Route exact path="team" element={<TeamPage />} />
                            <Route exact path="blog/tag/:tag" element={<BlogTag />} />
                            <Route exact path="blog/:slug" element={<BlogPage />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                        <WhatsAppButton />
                    </BrowserRouter>
                </LanguageProvider>
            </Fragment >
        );
    }
}

export default App;

